import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Dilemma: afvallen en de overgang!</title>
                <link rel="canonical" href={route("blogs.eighteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. We krijgen veel vragen van vrouwen die in de overgang zitten. Het afvalproces gaat moeizaam en ze weten niet wat te doen. In deze blog lees je er meer over!"
                />
                <meta
                    property="og:description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. We krijgen veel vragen van vrouwen die in de overgang zitten. Het afvalproces gaat moeizaam en ze weten niet wat te doen. In deze blog lees je er meer over!"
                />
                <meta property="og:url" content={route("blogs.eighteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Dilemma: afvallen en de overgang! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/afvallen-en-overgang.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/afvallen-en-overgang.webp"
                                    type="image/webp"
                                    alt="Afvallen en overgang"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/afvallen-en-overgang.jpg"
                                    type="image/jpeg"
                                    alt="Afvallen en overgang"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/afvallen-en-overgang.jpg"
                                    alt="Afvallen en overgang"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Dilemma: afvallen en de overgang!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – personal training Uden en Schijndel komt met
                        een nieuwe blog. We krijgen veel vragen van vrouwen die
                        in de overgang zitten. Het afvalproces gaat moeizaam en
                        ze weten niet wat te doen. In deze blog lees je er meer
                        over!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is de overgang?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De overgang is de periode van de laatste menstruatie. Na
                        deze periode is het niet meer mogelijk om een eisprong
                        te krijgen en geen baarmoederslijmvlies meer wordt
                        aangemaakt. Dit alles komt door de hormonale
                        veranderingen in deze periode, ook wel menopauze
                        genoemd. Vrouwen in de overgang merken dit vaak door
                        zweetaanvallen, opvliegers en dat de weegschaal opeens
                        niet meer doet wat je wilt! De overgang kan enkele jaren
                        duren tot je allerlaatste menstruatie is geweest.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom heeft deze veel invloed op je gewicht?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De belangrijkste reden zijn de hormonale veranderingen
                        tijdens deze periode. Progesteron neemt af wat betekent
                        dat je schildklier trager gaat werken. Daarnaast
                        verandert de vetverdeling over het lichaam. Veel vrouwen
                        zullen merken dat hun ‘muffin-topping’ toenemen. Het
                        randje vet boven je broek. Een andere reden is dat
                        oestrogeen afneemt in het lichaam. Het lichaam heeft dit
                        hormoon wel nodig en wordt aangemaakt in een andere vorm
                        van het lichaam: vet! Om ervoor te zorgen dat het
                        lichaam nog genoeg oestrogeen aanmaakt zullen vrouwen
                        merken dat het afvallen moeilijker wordt dan ooit
                        tevoren. De laatste reden die we allemaal ervaren is dat
                        naarmate we ouder worden we steeds meer spiermassa
                        verliezen. Hoe minder spiermassa we hebben, hoe minder
                        we verbranden in rusttoestand.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat helpt in deze periode?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voordat we een aantal adviezen gaan geven is het
                        belangrijk om te beseffen dat de overgang bij het vrouw
                        zijn hoort. Het is een natuurlijk proces waar je niet
                        onderuit komt. Zie het al een nieuwe fase van het leven
                        en omarm het.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je in deze periode zit hebben we een aantal
                        adviezen voor je om het afvallen makkelijker te maken:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li>
                            Pas je voeding aan: zorgt ervoor dat je een
                            calorietekort zit. Mogelijk is{" "}
                            <a
                                href={route("blogs.second")}
                                className="text-we-are-yellow"
                            >
                                intermittent fasting
                            </a>{" "}
                            een manier voor je die in deze periode goed werkt!
                        </li>
                        <li>
                            Doe meer krachttraining dan duursporten of cardio.{" "}
                            <a
                                href={route("blogs.fourth")}
                                className="text-we-are-yellow"
                            >
                                Krachttraining
                            </a>{" "}
                            heeft namelijk een zeer positief effect op je
                            hormonale balans. Daarnaast verbrand het meer
                            calorieën op lange termijn dan cardio.{" "}
                        </li>
                        <li>
                            Vermijd producten zoals alcohol. Alcohol bevat
                            namelijk zeven calorieën per gram. Daarnaast
                            verstoort het je herstelvermogen.{" "}
                        </li>
                        <li>
                            Gebruik{" "}
                            <a
                                href={route("blogs.fifteenth")}
                                className="text-we-are-yellow"
                            >
                                omega 3 vetzuren
                            </a>{" "}
                            als suppletie. Deze vorm van suppletie heeft een
                            positief effect op de overgang. Daarnaast is het
                            slikken van extra zink en Multi vitamine een goed
                            idee.{" "}
                        </li>
                        <li>
                            Eet als een holbewoner. Dit betekent dat alles wat
                            rent, zwem of vliegt gegeten kan worden. Alles wat
                            bewerkt is, is niet geschikt!{" "}
                        </li>
                    </ol>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
